import { useScroll } from "framer-motion";
import useMobile from "hooks/useMobile";
import debounce from "lodash.debounce";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

import urbanekaText from "assets/images/urbaneka-text.svg";
import urbanekaLogo from "assets/images/urbaneka-logo.svg";

type Prop = {
  children : JSX.Element | JSX.Element[]
} 
export default function Navbar({
    children
  } : Prop) {
  const [isScrollTop, setIsScrollTop] = useState((window.pageYOffset || document.documentElement.scrollTop) < 10);
  const isMobile = useMobile();
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [isScrollDirDown, setIsScrollDirDown] = useState(false);


  useEffect(()=>{
    setNavbarOpen(false);
  }, [isMobile])
  useEffect(() => {
    var lastPosition = window.pageYOffset || document.documentElement.scrollTop;
    function updateOpacity(ev: Event){
      let currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition < 10) {
        setIsScrollTop(true);
      }
      if (currentPosition < lastPosition) {
        setIsScrollDirDown(false);
      } else{
        setIsScrollDirDown(true);
        setIsScrollTop(false);
      }
      lastPosition = currentPosition;
    }

    const scrollListener = debounce(updateOpacity, 10)
    window.addEventListener('scroll', scrollListener);

    return () => {
      window.removeEventListener('scroll', scrollListener);
    }
  }, [])


  return (
    <>
      <nav className={"top-0 fixed z-10 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg transform transition"+
                        (!isScrollTop || navbarOpen ? " bg-white shadow" : "")+
                        (!isScrollDirDown ? "" : !isScrollTop && !navbarOpen ? " -translate-y-full" : "")}>
        <div className="container mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              to="/"
              className={ (!isScrollTop || navbarOpen ? "" : " text-white") + " text-sm font-bold leading-relaxed inline-block mr-4 whitespace-nowrap uppercase"}
            >
              <div className="flex h-8 gap-x-2 items-center">
                <img 
                  className={ "transition-all h-8 " +
                       (isScrollTop && !navbarOpen ? " filter brightness-0 invert" : '')
                    }
                  src={urbanekaLogo} alt="" 
                />
                <img className={" transition-all -mt-1 h-6 "
                    + (isScrollTop && !navbarOpen ? " filter brightness-0 invert " : '')  
                  } 
                  src={urbanekaText} alt="" 
                />
              </div>
            </Link>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className={"fas fa-bars" + (!isScrollTop || navbarOpen ? "" : " text-white")}></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block" : " hidden") +
              (!isScrollTop || navbarOpen ? "": " text-white")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto py-2 gap-y-3 lg:gap-y-0 lg:py-0 lg:gap-x-7"> 
              {children}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
